import { Container, Image, Paragraph, TextContent, Title } from './styles'

const Sobre = () => (
  <Container>
    <Image src="perfil.jpeg" />
    <TextContent>
      <Title>Sobre Mim</Title>
      <Paragraph>
        Com uma atuação carismática que une as experiências de palcos, os
        estúdios e a sala de aula, atuo como músico, produtor e educador musical
        há 3 anos!{' '}
      </Paragraph>
      <Paragraph>
        {' '}
        Minha abordagem integra a visão técnica da produção com a sensibilidade
        da execução instrumental, oferecendo uma formação completa e atualizada.
        Minha maior aptidão é desmistificar o processo musical. Acredito que o
        ensino de qualidade é a base para uma produção de excelência. Por isso,
        dedico minha carreira a mentorar alunos e profissionais, transformando
        curiosidade em domínio técnico e paixão em resultados sonoros
        profissionais.
      </Paragraph>
    </TextContent>
  </Container>
)

export default Sobre
